import { Wrapper } from '@googlemaps/react-wrapper';
import { useRef, useEffect } from 'react';

// Custom overlay class for circular markers
const createCustomMarker = () => {
    class CustomMarker extends window.google.maps.OverlayView {
        constructor(position, map, markerData) {
            super();
            this.position = position;
            this.markerData = markerData;
            this.setMap(map);
        }

    onAdd() {
        this.div = document.createElement('div');
        this.div.style.cssText = `
            position: absolute;
            color: white;
            background: ${this.markerData.background || 'grey'};
            padding: 15px 10px;
            display: flex;
            text-align: center;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            width: 75px;
            height: 75px;
            cursor: pointer;
            transform: translate(-50%, -50%);
            font-size: 12px;
            box-shadow: 0 2px 6px rgba(0,0,0,0.3);
        `;
        
        this.div.innerHTML = `
            <div>
                <i class="${this.markerData.icon || 'fas fa-home'} mb-6px"></i><br/>
                ${this.markerData.name}
            </div>
        `;
        
        this.div.addEventListener('click', () => {
            window.location.href = this.markerData.navLink;
        });
        
        const panes = this.getPanes();
        panes.overlayMouseTarget.appendChild(this.div);
    }

    draw() {
        const overlayProjection = this.getProjection();
        const position = overlayProjection.fromLatLngToDivPixel(this.position);
        
        if (this.div) {
            this.div.style.left = position.x + 'px';
            this.div.style.top = position.y + 'px';
        }
    }

    onRemove() {
        if (this.div) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        }
    }
    }
    return CustomMarker;
};

const MapComponent = ({ center, zoom, markers, className }) => {
    const mapRef = useRef(null);
    const map = useRef(null);
    const markersRef = useRef([]);

    useEffect(() => {
        if (!map.current && mapRef.current) {
            map.current = new window.google.maps.Map(mapRef.current, {
                center,
                zoom,
                className
            });
        }
    }, [center, zoom, className]);

    useEffect(() => {
        if (!map.current) return;

        // Clear existing markers
        markersRef.current.forEach(marker => marker.setMap(null));
        markersRef.current = [];

        // Add new custom markers
        const CustomMarker = createCustomMarker();
        markers.forEach(markerData => {
            if (!markerData.name) return;

            const position = new window.google.maps.LatLng(markerData.center.lat, markerData.center.lng);
            const customMarker = new CustomMarker(position, map.current, markerData);
            
            markersRef.current.push(customMarker);
        });
    }, [markers]);

    return <div ref={mapRef} style={{ width: '100%', height: '100%' }} />;
};

export const GoogleMap = (props) => {
    return (
        <div style={props.style}>
            <Wrapper apiKey={props.apiKey}>
                <MapComponent
                    center={props.center}
                    zoom={props.zoom}
                    markers={props.markers}
                    className={props.className}
                />
            </Wrapper>
        </div>
    );
}